// 大布局
import RefPage from './page/index';
import Header from './page/page-header';
import Aside from './page/aside';
import Content from './page/content';
import './index.scss';
// @ts-ignore
const CnLayoutPage = RefPage;
CnLayoutPage.Header = Header;
CnLayoutPage.Aside = Aside;
CnLayoutPage.Content = Content;
export { Header as CnLayoutHeader, Aside as CnLayoutAside, Content as CnLayoutContent };
export { CnLayoutPage };
export { default as CnLayoutSection } from './section';
export { default as CnLayoutBlock } from './block';
// 小布局
export { default as CnLayoutRow } from './row';
export { default as CnLayoutCol } from './col';
export { default as CnLayoutCell } from './cell';
export default CnLayoutPage;
